import '../styles/TeamScreen.css'
import { useEffect, useState } from "react"
import {showTeams} from "../services/teamService.js"
import TeamCard from "../components/componentsScreenTeams/teamCard.jsx"
import AdminContainer from '../components/AdminContainer.jsx'
import CreateTeamPanel from "../components/componentsScreenTeams/createTeamPanel.jsx"


export default function TeamScreen(){

    const [teams, setTeams] = useState([])
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [isOpen, setIsOpen] = useState(false)
    const [count, setCount] = useState(false)


    useEffect(() => {
        const checkTeams = async () => {
            const data = await showTeams(page)
            setTeams(data.data)
            setTotalPages(data.totalPage)
        }
        checkTeams()
    }, [page, count])

    return(
        <AdminContainer rols={['admin']}>
            <div className="create-group-panel">
            <div className="panel-header">
                <button className="refresh-btn" onClick={() => setIsOpen(!isOpen)}>Crear grupo</button>
            </div>
                {
                    isOpen&&(
                        <CreateTeamPanel  clousePanel={() => setIsOpen(!isOpen)}></CreateTeamPanel>
                    )
                }
                
            <div>
                <h2>Grupos</h2>
                <div>
                    {
                        teams.map((team, index) => (
                            <TeamCard key={index} handleRefreh={() => setCount(!count)} team={team}></TeamCard>
                        ))
                    }
                </div>
                <div className="pagination">
                    {
                    Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i}
                            onClick={() => setPage(i + 1)}
                            className={`pagination-btn ${page === i + 1 ? 'active' : ''}`}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>
            </div>
        </div>
        </AdminContainer>
       
    )
}